<div class="page-control">
    <div *ngIf="mini; then miniMode else maxMode"></div>
    <ng-template #miniMode>
      <div class="paginator">
        <button (click)="goToPreviousPage()" [class.disabled]="currentPage === 1">&lt;</button>
        <div class="current-page">{{ currentLocation }}</div>
        <button (click)="goToNextPage()" [class.disabled]="currentPage === totalPages">&gt;</button>
      </div>
    </ng-template>

    <ng-template #maxMode>
      <div class="paginator">
        <div *ngIf="enablePageSizeSelection" id="page-size-selector">
          <div>{{pageSizeDescription}}</div>
          <mat-select (valueChange)="selectPageSize($event)" [(value)]="pageSize">
            <mat-option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </div>
        <button (click)="goToPreviousPage()" [class.disabled]="currentPage === 1"
                [disabled]="currentPage === 1" class="next-page">&lt;
        </button>

        <button *ngFor="let page of pages"
                (click)="goToPage(page)"
                [class.active]="page === currentPage"
                [class.disabled]="page === '...'">
          {{ page }}
        </button>

        <button (click)="goToNextPage()"
                [class.disabled]="currentPage === totalPages" [disabled]="currentPage === totalPages" class="next-page">&gt;
        </button>
      </div>
    </ng-template>
</div>
<div *ngIf="rowControl" class="rows-per-page">
    <app-titled-input
        [control]="rowsControl"
        [title]="rowsTitle"
        [type]="'right'">
        <ng-content>
            <app-select-menu
              [selectMode]="SelectMode.SINGLE" [searchable]="false" [width]="'170px'" [selectAllAndClearOptions]="false"
              [control]="rowsControl" [items]="rowsOptions" (onApply)="changeRowsNumber($event)">
            </app-select-menu>
        </ng-content>
    </app-titled-input>
</div>
